@if (message()) {
  <div class="banner"
       [ngClass]="message()!.bannerType"
       [@messageChanged]>

    <div class="message">
      <div class="content"> {{message()!.content}}</div>
    </div>
    <div class="banner-actions row">
      @if (message()!.showRefreshButton) {
        <button mat-flat-button
                type="button"
                [color]="message()!.bannerType"
                (click)="refresh()">
          Refresh
        </button>
      }
      @if (!message()!.hideDismissButton) {
        <button mat-flat-button
                [color]="message()!.bannerType"
                type="button"
                (click)="dismissBanner()">
          Dismiss
        </button>
      }
      @if (message()!.template) {
        <ng-container *ngTemplateOutlet="message()!.template!" />
      }
      <ng-template #componentRef />
    </div>
  </div>
}